webpackJsonp(["filtered_search"],{

/***/ "./droplab/plugins/ajax.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__ = __webpack_require__("./lib/utils/ajax_cache.js");
/* eslint-disable */



var Ajax = {
  _loadData: function _loadData(data, config, self) {
    if (config.loadingTemplate) {
      var dataLoadingTemplate = self.hook.list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) dataLoadingTemplate.outerHTML = self.listTemplate;
    }

    if (!self.destroyed) self.hook.list[config.method].call(self.hook.list, data);
  },
  preprocessing: function preprocessing(config, data) {
    var results = data;

    if (config.preprocessing && !data.preprocessed) {
      results = config.preprocessing(data);
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].override(config.endpoint, results);
    }

    return results;
  },
  init: function init(hook) {
    var self = this;
    self.destroyed = false;
    var config = hook.config.Ajax;
    this.hook = hook;
    if (!config || !config.endpoint || !config.method) {
      return;
    }
    if (config.method !== 'setData' && config.method !== 'addData') {
      return;
    }
    if (config.loadingTemplate) {
      var dynamicList = hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', '');
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }

    return __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].retrieve(config.endpoint).then(self.preprocessing.bind(null, config)).then(function (data) {
      return self._loadData(data, config, self);
    }).catch(config.onError);
  },
  destroy: function destroy() {
    this.destroyed = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Ajax);

/***/ }),

/***/ "./droplab/plugins/ajax_filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__ = __webpack_require__("./lib/utils/ajax_cache.js");
/* eslint-disable */


var AjaxFilter = {
  init: function init(hook) {
    this.destroyed = false;
    this.hook = hook;
    this.notLoading();

    this.eventWrapper = {};
    this.eventWrapper.debounceTrigger = this.debounceTrigger.bind(this);
    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.addEventListener('focus', this.eventWrapper.debounceTrigger);

    this.trigger(true);
  },

  notLoading: function notLoading() {
    this.loading = false;
  },

  debounceTrigger: function debounceTrigger(e) {
    var NON_CHARACTER_KEYS = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93];
    var invalidKeyPressed = NON_CHARACTER_KEYS.indexOf(e.detail.which || e.detail.keyCode) > -1;
    var focusEvent = e.type === 'focus';
    if (invalidKeyPressed || this.loading) {
      return;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(this.trigger.bind(this, focusEvent), 200);
  },

  trigger: function trigger(getEntireList) {
    var _this = this;

    var config = this.hook.config.AjaxFilter;
    var searchValue = this.trigger.value;
    if (!config || !config.endpoint || !config.searchKey) {
      return;
    }
    if (config.searchValueFunction) {
      searchValue = config.searchValueFunction();
    }
    if (config.loadingTemplate && this.hook.list.data === undefined || this.hook.list.data.length === 0) {
      var dynamicList = this.hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', true);
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }
    if (getEntireList) {
      searchValue = '';
    }
    if (config.searchKey === searchValue) {
      return this.list.show();
    }
    this.loading = true;
    var params = config.params || {};
    params[config.searchKey] = searchValue;
    var url = config.endpoint + this.buildParams(params);
    return __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].retrieve(url).then(function (data) {
      _this._loadData(data, config);
      if (config.onLoadingFinished) {
        config.onLoadingFinished(data);
      }
    }).catch(config.onError);
  },

  _loadData: function _loadData(data, config) {
    var list = this.hook.list;
    if (config.loadingTemplate && list.data === undefined || list.data.length === 0) {
      var dataLoadingTemplate = list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) {
        dataLoadingTemplate.outerHTML = this.listTemplate;
      }
    }
    if (!this.destroyed) {
      var hookListChildren = list.list.children;
      var onlyDynamicList = hookListChildren.length === 1 && hookListChildren[0].hasAttribute('data-dynamic');
      if (onlyDynamicList && data.length === 0) {
        list.hide();
      }
      list.setData.call(list, data);
    }
    this.notLoading();
    list.currentIndex = 0;
  },


  buildParams: function buildParams(params) {
    if (!params) return '';
    var paramsArray = Object.keys(params).map(function (param) {
      return param + '=' + (params[param] || '');
    });
    return '?' + paramsArray.join('&');
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.removeEventListener('focus', this.eventWrapper.debounceTrigger);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AjaxFilter);

/***/ }),

/***/ "./droplab/plugins/filter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var Filter = {
  keydown: function keydown(e) {
    if (this.destroyed) return;

    var hiddenCount = 0;
    var dataHiddenCount = 0;

    var list = e.detail.hook.list;
    var data = list.data;
    var value = e.detail.hook.trigger.value.toLowerCase();
    var config = e.detail.hook.config.Filter;
    var matches = [];
    var filterFunction;
    // will only work on dynamically set data
    if (!data) {
      return;
    }

    if (config && config.filterFunction && typeof config.filterFunction === 'function') {
      filterFunction = config.filterFunction;
    } else {
      filterFunction = function filterFunction(o) {
        // cheap string search
        o.droplab_hidden = o[config.template].toLowerCase().indexOf(value) === -1;
        return o;
      };
    }

    dataHiddenCount = data.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    matches = data.map(function (o) {
      return filterFunction(o, value);
    });

    hiddenCount = matches.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    if (dataHiddenCount !== hiddenCount) {
      list.setData(matches);
      list.currentIndex = 0;
    }
  },

  debounceKeydown: function debounceKeydown(e) {
    if ([13, // enter
    16, // shift
    17, // ctrl
    18, // alt
    20, // caps lock
    37, // left arrow
    38, // up arrow
    39, // right arrow
    40, // down arrow
    91, // left window
    92, // right window
    93].indexOf(e.detail.which || e.detail.keyCode) > -1) return;

    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.keydown.bind(this, e), 200);
  },

  init: function init(hook) {
    var config = hook.config.Filter;

    if (!config || !config.template) return;

    this.hook = hook;
    this.destroyed = false;

    this.eventWrapper = {};
    this.eventWrapper.debounceKeydown = this.debounceKeydown.bind(this);

    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.addEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);

    this.debounceKeydown({ detail: { hook: this.hook } });
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.removeEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),

/***/ "./filtered_search/components/recent_searches_dropdown_content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub__ = __webpack_require__("./filtered_search/event_hub.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RecentSearchesDropdownContent',

  props: {
    items: {
      type: Array,
      required: true
    },
    isLocalStorageAvailable: {
      type: Boolean,
      required: false,
      default: true
    },
    allowedKeys: {
      type: Array,
      required: true
    }
  },

  computed: {
    processedItems: function processedItems() {
      var _this = this;

      return this.items.map(function (item) {
        var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(item, _this.allowedKeys),
            tokens = _gl$FilteredSearchTok.tokens,
            searchToken = _gl$FilteredSearchTok.searchToken;

        var resultantTokens = tokens.map(function (token) {
          return {
            prefix: token.key + ':',
            suffix: '' + token.symbol + token.value
          };
        });

        return {
          text: item,
          tokens: resultantTokens,
          searchToken: searchToken
        };
      });
    },
    hasItems: function hasItems() {
      return this.items.length > 0;
    }
  },

  methods: {
    onItemActivated: function onItemActivated(text) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub__["a" /* default */].$emit('recentSearchesItemSelected', text);
    },
    onRequestClearRecentSearches: function onRequestClearRecentSearches(e) {
      // Stop the dropdown from closing
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__event_hub__["a" /* default */].$emit('requestClearRecentSearches');
    }
  },

  template: '\n    <div>\n      <div\n        v-if="!isLocalStorageAvailable"\n        class="dropdown-info-note">\n        This feature requires local storage to be enabled\n      </div>\n      <ul v-else-if="hasItems">\n        <li\n          v-for="(item, index) in processedItems"\n          :key="index">\n          <button\n            type="button"\n            class="filtered-search-history-dropdown-item"\n            @click="onItemActivated(item.text)">\n            <span>\n              <span\n                v-for="(token, tokenIndex) in item.tokens"\n                class="filtered-search-history-dropdown-token">\n                <span class="name">{{ token.prefix }}</span><span class="value">{{ token.suffix }}</span>\n              </span>\n            </span>\n            <span class="filtered-search-history-dropdown-search-token">\n              {{ item.searchToken }}\n            </span>\n          </button>\n        </li>\n        <li class="divider"></li>\n        <li>\n          <button\n            type="button"\n            class="filtered-search-history-clear-button"\n            @click="onRequestClearRecentSearches($event)">\n            Clear recent searches\n          </button>\n        </li>\n      </ul>\n      <div\n        v-else\n        class="dropdown-info-note">\n        You don\'t have any recent searches\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./filtered_search/dropdown_hint.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_plugins_filter__ = __webpack_require__("./droplab/plugins/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown__ = __webpack_require__("./filtered_search/filtered_search_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DropdownHint = function (_gl$FilteredSearchDro) {
  _inherits(DropdownHint, _gl$FilteredSearchDro);

  function DropdownHint() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DropdownHint);

    var input = options.input,
        tokenKeys = options.tokenKeys;

    var _this = _possibleConstructorReturn(this, (DropdownHint.__proto__ || Object.getPrototypeOf(DropdownHint)).call(this, options));

    _this.config = {
      Filter: {
        template: 'hint',
        filterFunction: gl.DropdownUtils.filterHint.bind(null, {
          input: input,
          allowedKeys: tokenKeys.getKeys()
        })
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  _createClass(DropdownHint, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI') {
        if (selected.hasAttribute('data-value')) {
          this.dismissDropdown();
        } else if (selected.getAttribute('data-action') === 'submit') {
          this.dismissDropdown();
          this.dispatchFormSubmitEvent();
        } else {
          var token = selected.querySelector('.js-filter-hint').innerText.trim();
          var tag = selected.querySelector('.js-filter-tag').innerText.trim();

          if (tag.length) {
            // Get previous input values in the input field and convert them into visual tokens
            var previousInputValues = this.input.value.split(' ');
            var searchTerms = [];

            previousInputValues.forEach(function (value, index) {
              searchTerms.push(value);

              if (index === previousInputValues.length - 1 && token.indexOf(value.toLowerCase()) !== -1) {
                searchTerms.pop();
              }
            });

            if (searchTerms.length > 0) {
              gl.FilteredSearchVisualTokens.addSearchVisualToken(searchTerms.join(' '));
            }

            gl.FilteredSearchDropdownManager.addWordToInput(token.replace(':', ''), '', false, this.container);
          }
          this.dismissDropdown();
          this.dispatchInputEvent();
        }
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var dropdownData = this.tokenKeys.get().map(function (tokenKey) {
        return {
          icon: 'fa-' + tokenKey.icon,
          hint: tokenKey.key,
          tag: '<' + tokenKey.symbol + tokenKey.key + '>',
          type: tokenKey.type
        };
      });

      this.droplab.changeHookList(this.hookId, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_filter__["a" /* default */]], this.config);
      this.droplab.setData(this.hookId, dropdownData);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_filter__["a" /* default */]], this.config).init();
    }
  }]);

  return DropdownHint;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownHint = DropdownHint;

/***/ }),

/***/ "./filtered_search/dropdown_non_user.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax__ = __webpack_require__("./droplab/plugins/ajax.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_filter__ = __webpack_require__("./droplab/plugins/filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtered_search_dropdown__ = __webpack_require__("./filtered_search/filtered_search_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtered_search_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__filtered_search_dropdown__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Flash */





var DropdownNonUser = function (_gl$FilteredSearchDro) {
  _inherits(DropdownNonUser, _gl$FilteredSearchDro);

  function DropdownNonUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DropdownNonUser);

    var input = options.input,
        endpoint = options.endpoint,
        symbol = options.symbol,
        preprocessing = options.preprocessing;

    var _this = _possibleConstructorReturn(this, (DropdownNonUser.__proto__ || Object.getPrototypeOf(DropdownNonUser)).call(this, options));

    _this.symbol = symbol;
    _this.config = {
      Ajax: {
        endpoint: endpoint,
        method: 'setData',
        loadingTemplate: _this.loadingTemplate,
        preprocessing: preprocessing,
        onError: function onError() {
          /* eslint-disable no-new */
          new Flash('An error occured fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      },
      Filter: {
        filterFunction: gl.DropdownUtils.filterWithSymbol.bind(null, _this.symbol, input),
        template: 'title'
      }
    };
    return _this;
  }

  _createClass(DropdownNonUser, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var _this2 = this;

      _get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        var title = selected.querySelector('.js-data-value').innerText.trim();
        return '' + _this2.symbol + gl.DropdownUtils.getEscapedText(title);
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_filter__["a" /* default */]], this.config);
      _get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_filter__["a" /* default */]], this.config).init();
    }
  }]);

  return DropdownNonUser;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownNonUser = DropdownNonUser;

/***/ }),

/***/ "./filtered_search/dropdown_user.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax_filter__ = __webpack_require__("./droplab/plugins/ajax_filter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown__ = __webpack_require__("./filtered_search/filtered_search_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__filtered_search_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_dom_utils__ = __webpack_require__("./lib/utils/dom_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Flash */





var DropdownUser = function (_gl$FilteredSearchDro) {
  _inherits(DropdownUser, _gl$FilteredSearchDro);

  function DropdownUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DropdownUser);

    var tokenKeys = options.tokenKeys;

    var _this = _possibleConstructorReturn(this, (DropdownUser.__proto__ || Object.getPrototypeOf(DropdownUser)).call(this, options));

    _this.config = {
      AjaxFilter: {
        endpoint: (gon.relative_url_root || '') + '/autocomplete/users.json',
        searchKey: 'search',
        params: {
          per_page: 20,
          active: true,
          project_id: _this.getProjectId(),
          current_user: true
        },
        searchValueFunction: _this.getSearchInput.bind(_this),
        loadingTemplate: _this.loadingTemplate,
        onLoadingFinished: function onLoadingFinished() {
          _this.hideCurrentUser();
        },
        onError: function onError() {
          /* eslint-disable no-new */
          new Flash('An error occured fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  _createClass(DropdownUser, [{
    key: 'hideCurrentUser',
    value: function hideCurrentUser() {
      Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_dom_utils__["a" /* addClassIfElementExists */])(this.dropdown.querySelector('.js-current-user'), 'hidden');
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e) {
      _get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        return selected.querySelector('.dropdown-light-content').innerText.trim();
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax_filter__["a" /* default */]], this.config);
      _get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'getProjectId',
    value: function getProjectId() {
      return this.input.getAttribute('data-project-id');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var query = gl.DropdownUtils.getSearchInput(this.input);

      var _gl$FilteredSearchTok = gl.FilteredSearchTokenizer.processTokens(query, this.tokenKeys.get()),
          lastToken = _gl$FilteredSearchTok.lastToken;

      var value = lastToken || '';

      if (value[0] === '@') {
        value = value.slice(1);
      }

      // Removes the first character if it is a quotation so that we can search
      // with multiple words
      if (value[0] === '"' || value[0] === '\'') {
        value = value.slice(1);
      }

      return value;
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [__WEBPACK_IMPORTED_MODULE_0__droplab_plugins_ajax_filter__["a" /* default */]], this.config).init();
    }
  }]);

  return DropdownUser;
}(gl.FilteredSearchDropdown);

window.gl = window.gl || {};
gl.DropdownUser = DropdownUser;

/***/ }),

/***/ "./filtered_search/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ "./filtered_search/filtered_search_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdown_hint__ = __webpack_require__("./filtered_search/dropdown_hint.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_non_user__ = __webpack_require__("./filtered_search/dropdown_non_user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown_user__ = __webpack_require__("./filtered_search/dropdown_user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_token_keys__ = __webpack_require__("./filtered_search/filtered_search_token_keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_token_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filtered_search_token_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filtered_search_dropdown_manager__ = __webpack_require__("./filtered_search/filtered_search_dropdown_manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filtered_search_dropdown__ = __webpack_require__("./filtered_search/filtered_search_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filtered_search_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__filtered_search_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtered_search_manager__ = __webpack_require__("./filtered_search/filtered_search_manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filtered_search_tokenizer__ = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filtered_search_visual_tokens__ = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");











/***/ }),

/***/ "./filtered_search/filtered_search_dropdown.js":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DATA_DROPDOWN_TRIGGER = 'data-dropdown-trigger';

var FilteredSearchDropdown = function () {
  function FilteredSearchDropdown(_ref) {
    var droplab = _ref.droplab,
        dropdown = _ref.dropdown,
        input = _ref.input,
        filter = _ref.filter;

    _classCallCheck(this, FilteredSearchDropdown);

    this.droplab = droplab;
    this.hookId = input && input.id;
    this.input = input;
    this.filter = filter;
    this.dropdown = dropdown;
    this.loadingTemplate = '<div class="filter-dropdown-loading">\n      <i class="fa fa-spinner fa-spin"></i>\n    </div>';
    this.bindEvents();
  }

  _createClass(FilteredSearchDropdown, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.itemClickedWrapper = this.itemClicked.bind(this);
      this.dropdown.addEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.dropdown.removeEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'getCurrentHook',
    value: function getCurrentHook() {
      var _this = this;

      return this.droplab.hooks.filter(function (h) {
        return h.id === _this.hookId;
      })[0] || null;
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e, getValueFunction) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI' && selected.innerHTML) {
        var dataValueSet = gl.DropdownUtils.setDataValueIfSelected(this.filter, selected);

        if (!dataValueSet) {
          var value = getValueFunction(selected);
          gl.FilteredSearchDropdownManager.addWordToInput(this.filter, value, true);
        }

        this.resetFilters();
        this.dismissDropdown();
        this.dispatchInputEvent();
      }
    }
  }, {
    key: 'setAsDropdown',
    value: function setAsDropdown() {
      this.input.setAttribute(DATA_DROPDOWN_TRIGGER, '#' + this.dropdown.id);
    }
  }, {
    key: 'setOffset',
    value: function setOffset() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (window.innerWidth > 480) {
        this.dropdown.style.left = offset + 'px';
      } else {
        this.dropdown.style.left = '0px';
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var currentHook = this.getCurrentHook();
      if (forceShowList && currentHook && currentHook.list.hidden) {
        currentHook.list.show();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var forceRenderContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var forceShowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.setAsDropdown();

      var currentHook = this.getCurrentHook();
      var firstTimeInitialized = currentHook === null;

      if (firstTimeInitialized || forceRenderContent) {
        this.renderContent(forceShowList);
      } else if (currentHook.list.list.id !== this.dropdown.id) {
        this.renderContent(forceShowList);
      }
    }
  }, {
    key: 'dismissDropdown',
    value: function dismissDropdown() {
      // Focusing on the input will dismiss dropdown
      // (default droplab functionality)
      this.input.focus();
    }
  }, {
    key: 'dispatchInputEvent',
    value: function dispatchInputEvent() {
      // Propogate input change to FilteredSearchDropdownManager
      // so that it can determine which dropdowns to open
      this.input.dispatchEvent(new CustomEvent('input', {
        bubbles: true,
        cancelable: true
      }));
    }
  }, {
    key: 'dispatchFormSubmitEvent',
    value: function dispatchFormSubmitEvent() {
      // dispatchEvent() is necessary as form.submit() does not
      // trigger event handlers
      this.input.form.dispatchEvent(new Event('submit'));
    }
  }, {
    key: 'hideDropdown',
    value: function hideDropdown() {
      var currentHook = this.getCurrentHook();
      if (currentHook) {
        currentHook.list.hide();
      }
    }
  }, {
    key: 'resetFilters',
    value: function resetFilters() {
      var hook = this.getCurrentHook();

      if (hook) {
        var data = hook.list.data || [];
        var results = data.map(function (o) {
          var updated = o;
          updated.droplab_hidden = false;
          return updated;
        });
        hook.list.render(results);
      }
    }
  }]);

  return FilteredSearchDropdown;
}();

window.gl = window.gl || {};
gl.FilteredSearchDropdown = FilteredSearchDropdown;

/***/ }),

/***/ "./filtered_search/filtered_search_dropdown_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__ = __webpack_require__("./droplab/drop_lab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./filtered_search/container.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var FilteredSearchDropdownManager = function () {
  function FilteredSearchDropdownManager() {
    var baseEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var tokenizer = arguments[1];
    var page = arguments[2];

    _classCallCheck(this, FilteredSearchDropdownManager);

    this.container = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container;
    this.baseEndpoint = baseEndpoint.replace(/\/$/, '');
    this.tokenizer = tokenizer;
    this.filteredSearchTokenKeys = gl.FilteredSearchTokenKeys;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.page = page;

    this.setupMapping();

    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  _createClass(FilteredSearchDropdownManager, [{
    key: 'cleanup',
    value: function cleanup() {
      if (this.droplab) {
        this.droplab.destroy();
        this.droplab = null;
      }

      this.setupMapping();

      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'setupMapping',
    value: function setupMapping() {
      this.mapping = {
        author: {
          reference: null,
          gl: 'DropdownUser',
          element: this.container.querySelector('#js-dropdown-author')
        },
        assignee: {
          reference: null,
          gl: 'DropdownUser',
          element: this.container.querySelector('#js-dropdown-assignee')
        },
        milestone: {
          reference: null,
          gl: 'DropdownNonUser',
          extraArguments: {
            endpoint: this.baseEndpoint + '/milestones.json',
            symbol: '%'
          },
          element: this.container.querySelector('#js-dropdown-milestone')
        },
        label: {
          reference: null,
          gl: 'DropdownNonUser',
          extraArguments: {
            endpoint: this.baseEndpoint + '/labels.json',
            symbol: '~',
            preprocessing: gl.DropdownUtils.duplicateLabelPreprocessing
          },
          element: this.container.querySelector('#js-dropdown-label')
        },
        hint: {
          reference: null,
          gl: 'DropdownHint',
          element: this.container.querySelector('#js-dropdown-hint')
        }
      };
    }
  }, {
    key: 'updateCurrentDropdownOffset',
    value: function updateCurrentDropdownOffset() {
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'updateDropdownOffset',
    value: function updateDropdownOffset(key) {
      // Always align dropdown with the input field
      var offset = this.filteredSearchInput.getBoundingClientRect().left - this.container.querySelector('.scroll-container').getBoundingClientRect().left;

      var maxInputWidth = 240;
      var currentDropdownWidth = this.mapping[key].element.clientWidth || maxInputWidth;

      // Make sure offset never exceeds the input container
      var offsetMaxWidth = this.container.querySelector('.scroll-container').clientWidth - currentDropdownWidth;
      if (offsetMaxWidth < offset) {
        offset = offsetMaxWidth;
      }

      this.mapping[key].reference.setOffset(offset);
    }
  }, {
    key: 'load',
    value: function load(key) {
      var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var mappingKey = this.mapping[key];
      var glClass = mappingKey.gl;
      var element = mappingKey.element;
      var forceShowList = false;

      if (!mappingKey.reference) {
        var defaultArguments = {
          droplab: this.droplab,
          dropdown: element,
          input: this.filteredSearchInput,
          tokenKeys: this.filteredSearchTokenKeys,
          filter: key
        };
        var extraArguments = mappingKey.extraArguments || {};
        var glArguments = Object.assign({}, defaultArguments, extraArguments);

        // Passing glArguments to `new gl[glClass](<arguments>)`
        mappingKey.reference = new (Function.prototype.bind.apply(gl[glClass], [null, glArguments]))();
      }

      if (firstLoad) {
        mappingKey.reference.init();
      }

      if (this.currentDropdown === 'hint') {
        // Force the dropdown to show if it was clicked from the hint dropdown
        forceShowList = true;
      }

      this.updateDropdownOffset(key);
      mappingKey.reference.render(firstLoad, forceShowList);

      this.currentDropdown = key;
    }
  }, {
    key: 'loadDropdown',
    value: function loadDropdown() {
      var dropdownName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var firstLoad = false;

      if (!this.droplab) {
        firstLoad = true;
        this.droplab = new __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__["a" /* default */]();
      }

      var match = this.filteredSearchTokenKeys.searchByKey(dropdownName.toLowerCase());
      var shouldOpenFilterDropdown = match && this.currentDropdown !== match.key && this.mapping[match.key];
      var shouldOpenHintDropdown = !match && this.currentDropdown !== 'hint';

      if (shouldOpenFilterDropdown || shouldOpenHintDropdown) {
        var key = match && match.key ? match.key : 'hint';
        this.load(key, firstLoad);
      }
    }
  }, {
    key: 'setDropdown',
    value: function setDropdown() {
      var query = gl.DropdownUtils.getSearchQuery(true);

      var _tokenizer$processTok = this.tokenizer.processTokens(query, this.filteredSearchTokenKeys.getKeys()),
          lastToken = _tokenizer$processTok.lastToken,
          searchToken = _tokenizer$processTok.searchToken;

      if (this.currentDropdown) {
        this.updateCurrentDropdownOffset();
      }

      if (lastToken === searchToken && lastToken !== null) {
        // Token is not fully initialized yet because it has no value
        // Eg. token = 'label:'

        var split = lastToken.split(':');
        var dropdownName = _.last(split[0].split(' '));
        this.loadDropdown(split.length > 1 ? dropdownName : '');
      } else if (lastToken) {
        // Token has been initialized into an object because it has a value
        this.loadDropdown(lastToken.key);
      } else {
        this.loadDropdown('hint');
      }
    }
  }, {
    key: 'resetDropdowns',
    value: function resetDropdowns() {
      if (!this.currentDropdown) {
        return;
      }

      // Force current dropdown to hide
      this.mapping[this.currentDropdown].reference.hideDropdown();

      // Re-Load dropdown
      this.setDropdown();

      // Reset filters for current dropdown
      this.mapping[this.currentDropdown].reference.resetFilters();

      // Reposition dropdown so that it is aligned with cursor
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'destroyDroplab',
    value: function destroyDroplab() {
      this.droplab.destroy();
    }
  }], [{
    key: 'addWordToInput',
    value: function addWordToInput(tokenName) {
      var tokenValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var clicked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var input = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container.querySelector('.filtered-search');

      gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenName, tokenValue);
      input.value = '';

      if (clicked) {
        gl.FilteredSearchVisualTokens.moveInputToTheRight();
      }
    }
  }]);

  return FilteredSearchDropdownManager;
}();

window.gl = window.gl || {};
gl.FilteredSearchDropdownManager = FilteredSearchDropdownManager;

/***/ }),

/***/ "./filtered_search/filtered_search_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__("./filtered_search/container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recent_searches_root__ = __webpack_require__("./filtered_search/recent_searches_root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_recent_searches_store__ = __webpack_require__("./filtered_search/stores/recent_searches_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_recent_searches_service__ = __webpack_require__("./filtered_search/services/recent_searches_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_hub__ = __webpack_require__("./filtered_search/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_dom_utils__ = __webpack_require__("./lib/utils/dom_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var FilteredSearchManager = function () {
  function FilteredSearchManager(page) {
    _classCallCheck(this, FilteredSearchManager);

    this.page = page;
    this.container = __WEBPACK_IMPORTED_MODULE_0__container__["a" /* default */].container;
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.filteredSearchInputForm = this.filteredSearchInput.form;
    this.clearSearchButton = this.container.querySelector('.clear-search');
    this.tokensContainer = this.container.querySelector('.tokens-container');
    this.filteredSearchTokenKeys = gl.FilteredSearchTokenKeys;

    this.recentSearchesStore = new __WEBPACK_IMPORTED_MODULE_2__stores_recent_searches_store__["a" /* default */]({
      isLocalStorageAvailable: __WEBPACK_IMPORTED_MODULE_3__services_recent_searches_service__["a" /* default */].isAvailable(),
      allowedKeys: this.filteredSearchTokenKeys.getKeys()
    });
    this.searchHistoryDropdownElement = document.querySelector('.js-filtered-search-history-dropdown');
    var fullPath = this.searchHistoryDropdownElement ? this.searchHistoryDropdownElement.dataset.fullPath : 'project';
    var recentSearchesPagePrefix = 'issue-recent-searches';
    if (this.page === 'merge_requests') {
      recentSearchesPagePrefix = 'merge-request-recent-searches';
    }
    var recentSearchesKey = fullPath + '-' + recentSearchesPagePrefix;
    this.recentSearchesService = new __WEBPACK_IMPORTED_MODULE_3__services_recent_searches_service__["a" /* default */](recentSearchesKey);
  }

  _createClass(FilteredSearchManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      // Fetch recent searches from localStorage
      this.fetchingRecentSearchesPromise = this.recentSearchesService.fetch().catch(function (error) {
        if (error.name === 'RecentSearchesServiceError') return undefined;
        // eslint-disable-next-line no-new
        new window.Flash('An error occured while parsing recent searches');
        // Gracefully fail to empty array
        return [];
      }).then(function (searches) {
        if (!searches) {
          return;
        }

        // Put any searches that may have come in before
        // we fetched the saved searches ahead of the already saved ones
        var resultantSearches = _this.recentSearchesStore.setRecentSearches(_this.recentSearchesStore.state.recentSearches.concat(searches));
        _this.recentSearchesService.save(resultantSearches);
      });

      if (this.filteredSearchInput) {
        this.tokenizer = gl.FilteredSearchTokenizer;
        this.dropdownManager = new gl.FilteredSearchDropdownManager(this.filteredSearchInput.getAttribute('data-base-endpoint') || '', this.tokenizer, this.page);

        this.recentSearchesRoot = new __WEBPACK_IMPORTED_MODULE_1__recent_searches_root__["a" /* default */](this.recentSearchesStore, this.recentSearchesService, this.searchHistoryDropdownElement);
        this.recentSearchesRoot.init();

        this.bindEvents();
        this.loadSearchParamsFromURL();
        this.dropdownManager.setDropdown();

        this.cleanupWrapper = this.cleanup.bind(this);
        document.addEventListener('beforeunload', this.cleanupWrapper);
      }
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);

      if (this.recentSearchesRoot) {
        this.recentSearchesRoot.destroy();
      }
    }
  }, {
    key: 'bindStateEvents',
    value: function bindStateEvents() {
      this.stateFilters = document.querySelector('.container-fluid .issues-state-filters');

      if (this.stateFilters) {
        this.searchStateWrapper = this.searchState.bind(this);

        this.stateFilters.querySelector('[data-state="opened"]').addEventListener('click', this.searchStateWrapper);
        this.stateFilters.querySelector('[data-state="closed"]').addEventListener('click', this.searchStateWrapper);
        this.stateFilters.querySelector('[data-state="all"]').addEventListener('click', this.searchStateWrapper);

        this.mergedState = this.stateFilters.querySelector('[data-state="merged"]');
        if (this.mergedState) {
          this.mergedState.addEventListener('click', this.searchStateWrapper);
        }
      }
    }
  }, {
    key: 'unbindStateEvents',
    value: function unbindStateEvents() {
      if (this.stateFilters) {
        this.stateFilters.querySelector('[data-state="opened"]').removeEventListener('click', this.searchStateWrapper);
        this.stateFilters.querySelector('[data-state="closed"]').removeEventListener('click', this.searchStateWrapper);
        this.stateFilters.querySelector('[data-state="all"]').removeEventListener('click', this.searchStateWrapper);

        if (this.mergedState) {
          this.mergedState.removeEventListener('click', this.searchStateWrapper);
        }
      }
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.setDropdownWrapper = this.dropdownManager.setDropdown.bind(this.dropdownManager);
      this.toggleClearSearchButtonWrapper = this.toggleClearSearchButton.bind(this);
      this.handleInputPlaceholderWrapper = this.handleInputPlaceholder.bind(this);
      this.handleInputVisualTokenWrapper = this.handleInputVisualToken.bind(this);
      this.checkForEnterWrapper = this.checkForEnter.bind(this);
      this.onClearSearchWrapper = this.onClearSearch.bind(this);
      this.checkForBackspaceWrapper = this.checkForBackspace.bind(this);
      this.removeSelectedTokenKeydownWrapper = this.removeSelectedTokenKeydown.bind(this);
      this.unselectEditTokensWrapper = this.unselectEditTokens.bind(this);
      this.editTokenWrapper = this.editToken.bind(this);
      this.tokenChange = this.tokenChange.bind(this);
      this.addInputContainerFocusWrapper = this.addInputContainerFocus.bind(this);
      this.removeInputContainerFocusWrapper = this.removeInputContainerFocus.bind(this);
      this.onrecentSearchesItemSelectedWrapper = this.onrecentSearchesItemSelected.bind(this);
      this.removeTokenWrapper = this.removeToken.bind(this);

      this.filteredSearchInputForm.addEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.addEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.addEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.addEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.addEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.addEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.addEventListener('click', this.tokenChange);
      this.filteredSearchInput.addEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.addEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.addEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.addEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.addEventListener('click', this.onClearSearchWrapper);
      document.addEventListener('click', this.unselectEditTokensWrapper);
      document.addEventListener('click', this.removeInputContainerFocusWrapper);
      document.addEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$on('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.bindStateEvents();
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.filteredSearchInputForm.removeEventListener('submit', this.handleFormSubmit);
      this.filteredSearchInput.removeEventListener('input', this.setDropdownWrapper);
      this.filteredSearchInput.removeEventListener('input', this.toggleClearSearchButtonWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputPlaceholderWrapper);
      this.filteredSearchInput.removeEventListener('input', this.handleInputVisualTokenWrapper);
      this.filteredSearchInput.removeEventListener('keydown', this.checkForEnterWrapper);
      this.filteredSearchInput.removeEventListener('keyup', this.checkForBackspaceWrapper);
      this.filteredSearchInput.removeEventListener('click', this.tokenChange);
      this.filteredSearchInput.removeEventListener('keyup', this.tokenChange);
      this.filteredSearchInput.removeEventListener('focus', this.addInputContainerFocusWrapper);
      this.tokensContainer.removeEventListener('click', this.removeTokenWrapper);
      this.tokensContainer.removeEventListener('click', this.editTokenWrapper);
      this.clearSearchButton.removeEventListener('click', this.onClearSearchWrapper);
      document.removeEventListener('click', this.unselectEditTokensWrapper);
      document.removeEventListener('click', this.removeInputContainerFocusWrapper);
      document.removeEventListener('keydown', this.removeSelectedTokenKeydownWrapper);
      __WEBPACK_IMPORTED_MODULE_4__event_hub__["a" /* default */].$off('recentSearchesItemSelected', this.onrecentSearchesItemSelectedWrapper);

      this.unbindStateEvents();
    }
  }, {
    key: 'checkForBackspace',
    value: function checkForBackspace(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        var _gl$FilteredSearchVis = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
            lastVisualToken = _gl$FilteredSearchVis.lastVisualToken;

        var sanitizedTokenName = lastVisualToken && lastVisualToken.querySelector('.name').textContent.trim();
        var canEdit = sanitizedTokenName && this.canEdit && this.canEdit(sanitizedTokenName);
        if (this.filteredSearchInput.value === '' && lastVisualToken && canEdit) {
          this.filteredSearchInput.value = gl.FilteredSearchVisualTokens.getLastTokenPartial();
          gl.FilteredSearchVisualTokens.removeLastTokenPartial();
        }

        // Reposition dropdown so that it is aligned with cursor
        this.dropdownManager.updateCurrentDropdownOffset();
      }
    }
  }, {
    key: 'checkForEnter',
    value: function checkForEnter(e) {
      if (e.keyCode === 38 || e.keyCode === 40) {
        var selectionStart = this.filteredSearchInput.selectionStart;

        e.preventDefault();
        this.filteredSearchInput.setSelectionRange(selectionStart, selectionStart);
      }

      if (e.keyCode === 13) {
        var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];
        var dropdownEl = dropdown.element;
        var activeElements = dropdownEl.querySelectorAll('.droplab-item-active');

        e.preventDefault();

        if (!activeElements.length) {
          if (this.isHandledAsync) {
            e.stopImmediatePropagation();

            this.filteredSearchInput.blur();
            this.dropdownManager.resetDropdowns();
          } else {
            // Prevent droplab from opening dropdown
            this.dropdownManager.destroyDroplab();
          }

          this.search();
        }
      }
    }
  }, {
    key: 'addInputContainerFocus',
    value: function addInputContainerFocus() {
      Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_dom_utils__["a" /* addClassIfElementExists */])(this.filteredSearchInput.closest('.filtered-search-box'), 'focus');
    }
  }, {
    key: 'removeInputContainerFocus',
    value: function removeInputContainerFocus(e) {
      var inputContainer = this.filteredSearchInput.closest('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInDynamicFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementInStaticFilterDropdown = e.target.closest('ul[data-dropdown]') !== null;

      if (!isElementInFilteredSearch && !isElementInDynamicFilterDropdown && !isElementInStaticFilterDropdown && inputContainer) {
        inputContainer.classList.remove('focus');
      }
    }
  }, {
    key: 'removeToken',
    value: function removeToken(e) {
      var removeButtonSelected = e.target.closest('.remove-token');

      if (removeButtonSelected) {
        e.preventDefault();
        // Prevent editToken from being triggered after token is removed
        e.stopImmediatePropagation();

        var button = e.target.closest('.selectable');
        gl.FilteredSearchVisualTokens.selectToken(button, true);
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'unselectEditTokens',
    value: function unselectEditTokens(e) {
      var inputContainer = this.container.querySelector('.filtered-search-box');
      var isElementInFilteredSearch = inputContainer && inputContainer.contains(e.target);
      var isElementInFilterDropdown = e.target.closest('.filter-dropdown') !== null;
      var isElementTokensContainer = e.target.classList.contains('tokens-container');

      if (!isElementInFilteredSearch && !isElementInFilterDropdown || isElementTokensContainer) {
        gl.FilteredSearchVisualTokens.moveInputToTheRight();
        this.dropdownManager.resetDropdowns();
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(e) {
      var token = e.target.closest('.js-visual-token');
      var sanitizedTokenName = token && token.querySelector('.name').textContent.trim();
      var canEdit = this.canEdit && this.canEdit(sanitizedTokenName);

      if (token && canEdit) {
        e.preventDefault();
        e.stopPropagation();
        gl.FilteredSearchVisualTokens.editToken(token);
        this.tokenChange();
      }
    }
  }, {
    key: 'toggleClearSearchButton',
    value: function toggleClearSearchButton() {
      var query = gl.DropdownUtils.getSearchQuery();
      var hidden = 'hidden';
      var hasHidden = this.clearSearchButton.classList.contains(hidden);

      if (query.length === 0 && !hasHidden) {
        this.clearSearchButton.classList.add(hidden);
      } else if (query.length && hasHidden) {
        this.clearSearchButton.classList.remove(hidden);
      }
    }
  }, {
    key: 'handleInputPlaceholder',
    value: function handleInputPlaceholder() {
      var query = gl.DropdownUtils.getSearchQuery();
      var placeholder = 'Search or filter results...';
      var currentPlaceholder = this.filteredSearchInput.placeholder;

      if (query.length === 0 && currentPlaceholder !== placeholder) {
        this.filteredSearchInput.placeholder = placeholder;
      } else if (query.length > 0 && currentPlaceholder !== '') {
        this.filteredSearchInput.placeholder = '';
      }
    }
  }, {
    key: 'removeSelectedTokenKeydown',
    value: function removeSelectedTokenKeydown(e) {
      // 8 = Backspace Key
      // 46 = Delete Key
      if (e.keyCode === 8 || e.keyCode === 46) {
        this.removeSelectedToken();
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      gl.FilteredSearchVisualTokens.removeSelectedToken();
      this.handleInputPlaceholder();
      this.toggleClearSearchButton();
      this.dropdownManager.updateCurrentDropdownOffset();
    }
  }, {
    key: 'onClearSearch',
    value: function onClearSearch(e) {
      e.preventDefault();
      this.clearSearch();
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      this.filteredSearchInput.value = '';

      var removeElements = [];

      [].forEach.call(this.tokensContainer.children, function (t) {
        if (t.classList.contains('js-visual-token')) {
          removeElements.push(t);
        }
      });

      removeElements.forEach(function (el) {
        el.parentElement.removeChild(el);
      });

      this.clearSearchButton.classList.add('hidden');
      this.handleInputPlaceholder();

      this.dropdownManager.resetDropdowns();

      if (this.isHandledAsync) {
        this.search();
      }
    }
  }, {
    key: 'handleInputVisualToken',
    value: function handleInputVisualToken() {
      var input = this.filteredSearchInput;

      var _tokenizer$processTok = this.tokenizer.processTokens(input.value, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok.tokens,
          searchToken = _tokenizer$processTok.searchToken;

      var _gl$FilteredSearchVis2 = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _gl$FilteredSearchVis2.isLastVisualTokenValid;

      if (isLastVisualTokenValid) {
        tokens.forEach(function (t) {
          input.value = input.value.replace(t.key + ':' + t.symbol + t.value, '');
          gl.FilteredSearchVisualTokens.addFilterVisualToken(t.key, '' + t.symbol + t.value);
        });

        var fragments = searchToken.split(':');
        if (fragments.length > 1) {
          var inputValues = fragments[0].split(' ');
          var tokenKey = _.last(inputValues);

          if (inputValues.length > 1) {
            inputValues.pop();
            var searchTerms = inputValues.join(' ');

            input.value = input.value.replace(searchTerms, '');
            gl.FilteredSearchVisualTokens.addSearchVisualToken(searchTerms);
          }

          gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenKey);
          input.value = input.value.replace(tokenKey + ':', '');
        }
      } else {
        // Keep listening to token until we determine that the user is done typing the token value
        var valueCompletedRegex = /([~%@]{0,1}".+")|([~%@]{0,1}'.+')|^((?![~%@]')(?![~%@]")(?!')(?!")).*/g;

        if (searchToken.match(valueCompletedRegex) && input.value[input.value.length - 1] === ' ') {
          gl.FilteredSearchVisualTokens.addFilterVisualToken(searchToken);

          // Trim the last space as seen in the if statement above
          input.value = input.value.replace(searchToken, '').trim();
        }
      }
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.search();
    }
  }, {
    key: 'saveCurrentSearchQuery',
    value: function saveCurrentSearchQuery() {
      var _this2 = this;

      // Don't save before we have fetched the already saved searches
      this.fetchingRecentSearchesPromise.then(function () {
        var searchQuery = gl.DropdownUtils.getSearchQuery();
        if (searchQuery.length > 0) {
          var resultantSearches = _this2.recentSearchesStore.addRecentSearch(searchQuery);
          _this2.recentSearchesService.save(resultantSearches);
        }
      }).catch(function () {
        // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
      });
    }
  }, {
    key: 'loadSearchParamsFromURL',
    value: function loadSearchParamsFromURL() {
      var _this3 = this;

      var params = gl.utils.getUrlParamsArray();
      var usernameParams = this.getUsernameParams();
      var hasFilteredSearch = false;

      params.forEach(function (p) {
        var split = p.split('=');
        var keyParam = decodeURIComponent(split[0]);
        var value = split[1];

        // Check if it matches edge conditions listed in this.filteredSearchTokenKeys
        var condition = _this3.filteredSearchTokenKeys.searchByConditionUrl(p);

        if (condition) {
          hasFilteredSearch = true;
          var canEdit = _this3.canEdit && _this3.canEdit(condition.tokenKey);
          gl.FilteredSearchVisualTokens.addFilterVisualToken(condition.tokenKey, condition.value, canEdit);
        } else {
          // Sanitize value since URL converts spaces into +
          // Replace before decode so that we know what was originally + versus the encoded +
          var sanitizedValue = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : value;
          var match = _this3.filteredSearchTokenKeys.searchByKeyParam(keyParam);

          if (match) {
            var indexOf = keyParam.indexOf('_');
            var sanitizedKey = indexOf !== -1 ? keyParam.slice(0, keyParam.indexOf('_')) : keyParam;
            var symbol = match.symbol;
            var quotationsToUse = '';

            if (sanitizedValue.indexOf(' ') !== -1) {
              // Prefer ", but use ' if required
              quotationsToUse = sanitizedValue.indexOf('"') === -1 ? '"' : '\'';
            }

            hasFilteredSearch = true;
            var _canEdit = _this3.canEdit && _this3.canEdit(sanitizedKey);
            gl.FilteredSearchVisualTokens.addFilterVisualToken(sanitizedKey, '' + symbol + quotationsToUse + sanitizedValue + quotationsToUse, _canEdit);
          } else if (!match && keyParam === 'assignee_id') {
            var id = parseInt(value, 10);
            if (usernameParams[id]) {
              hasFilteredSearch = true;
              var tokenName = 'assignee';
              var _canEdit2 = _this3.canEdit && _this3.canEdit(tokenName);
              gl.FilteredSearchVisualTokens.addFilterVisualToken(tokenName, '@' + usernameParams[id], _canEdit2);
            }
          } else if (!match && keyParam === 'author_id') {
            var _id = parseInt(value, 10);
            if (usernameParams[_id]) {
              hasFilteredSearch = true;
              var _tokenName = 'author';
              var _canEdit3 = _this3.canEdit && _this3.canEdit(_tokenName);
              gl.FilteredSearchVisualTokens.addFilterVisualToken(_tokenName, '@' + usernameParams[_id], _canEdit3);
            }
          } else if (!match && keyParam === 'search') {
            hasFilteredSearch = true;
            _this3.filteredSearchInput.value = sanitizedValue;
          }
        }
      });

      this.saveCurrentSearchQuery();

      if (hasFilteredSearch) {
        this.clearSearchButton.classList.remove('hidden');
        this.handleInputPlaceholder();
      }
    }
  }, {
    key: 'searchState',
    value: function searchState(e) {
      e.preventDefault();
      var target = e.currentTarget;
      // remove focus outline after click
      target.blur();

      var state = target.dataset && target.dataset.state;

      if (state) {
        this.search(state);
      }
    }
  }, {
    key: 'search',
    value: function search() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var paths = [];
      var searchQuery = gl.DropdownUtils.getSearchQuery();

      this.saveCurrentSearchQuery();

      var _tokenizer$processTok2 = this.tokenizer.processTokens(searchQuery, this.filteredSearchTokenKeys.getKeys()),
          tokens = _tokenizer$processTok2.tokens,
          searchToken = _tokenizer$processTok2.searchToken;

      var currentState = state || gl.utils.getParameterByName('state') || 'opened';
      paths.push('state=' + currentState);

      tokens.forEach(function (token) {
        var condition = _this4.filteredSearchTokenKeys.searchByConditionKeyValue(token.key, token.value.toLowerCase());

        var _ref = _this4.filteredSearchTokenKeys.searchByKey(token.key) || {},
            param = _ref.param;

        var keyParam = param ? token.key + '_' + param : token.key;
        var tokenPath = '';

        if (condition) {
          tokenPath = condition.url;
        } else {
          var tokenValue = token.value;

          if (tokenValue[0] === '\'' && tokenValue[tokenValue.length - 1] === '\'' || tokenValue[0] === '"' && tokenValue[tokenValue.length - 1] === '"') {
            tokenValue = tokenValue.slice(1, tokenValue.length - 1);
          }

          tokenPath = keyParam + '=' + encodeURIComponent(tokenValue);
        }

        paths.push(tokenPath);
      });

      if (searchToken) {
        var sanitized = searchToken.split(' ').map(function (t) {
          return encodeURIComponent(t);
        }).join('+');
        paths.push('search=' + sanitized);
      }

      var parameterizedUrl = '?scope=all&utf8=%E2%9C%93&' + paths.join('&');

      if (this.updateObject) {
        this.updateObject(parameterizedUrl);
      } else {
        gl.utils.visitUrl(parameterizedUrl);
      }
    }
  }, {
    key: 'getUsernameParams',
    value: function getUsernameParams() {
      var usernamesById = {};
      try {
        var attribute = this.filteredSearchInput.getAttribute('data-username-params');
        JSON.parse(attribute).forEach(function (user) {
          usernamesById[user.id] = user.username;
        });
      } catch (e) {
        // do nothing
      }
      return usernamesById;
    }
  }, {
    key: 'tokenChange',
    value: function tokenChange() {
      var dropdown = this.dropdownManager.mapping[this.dropdownManager.currentDropdown];

      if (dropdown) {
        var currentDropdownRef = dropdown.reference;

        this.setDropdownWrapper();
        currentDropdownRef.dispatchInputEvent();
      }
    }
  }, {
    key: 'onrecentSearchesItemSelected',
    value: function onrecentSearchesItemSelected(text) {
      this.clearSearch();
      this.filteredSearchInput.value = text;
      this.filteredSearchInput.dispatchEvent(new CustomEvent('input'));
      this.search();
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return true;
    }
  }]);

  return FilteredSearchManager;
}();

window.gl = window.gl || {};
gl.FilteredSearchManager = FilteredSearchManager;

/***/ }),

/***/ "./filtered_search/filtered_search_token_keys.js":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tokenKeys = [{
  key: 'author',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'pencil'
}, {
  key: 'assignee',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'user'
}, {
  key: 'milestone',
  type: 'string',
  param: 'title',
  symbol: '%',
  icon: 'clock-o'
}, {
  key: 'label',
  type: 'array',
  param: 'name[]',
  symbol: '~',
  icon: 'tag'
}];

var alternativeTokenKeys = [{
  key: 'label',
  type: 'string',
  param: 'name',
  symbol: '~'
}];

var tokenKeysWithAlternative = tokenKeys.concat(alternativeTokenKeys);

var conditions = [{
  url: 'assignee_id=0',
  tokenKey: 'assignee',
  value: 'none'
}, {
  url: 'milestone_title=No+Milestone',
  tokenKey: 'milestone',
  value: 'none'
}, {
  url: 'milestone_title=%23upcoming',
  tokenKey: 'milestone',
  value: 'upcoming'
}, {
  url: 'milestone_title=%23started',
  tokenKey: 'milestone',
  value: 'started'
}, {
  url: 'label_name[]=No+Label',
  tokenKey: 'label',
  value: 'none'
}];

var FilteredSearchTokenKeys = function () {
  function FilteredSearchTokenKeys() {
    _classCallCheck(this, FilteredSearchTokenKeys);
  }

  _createClass(FilteredSearchTokenKeys, null, [{
    key: 'get',
    value: function get() {
      return tokenKeys;
    }
  }, {
    key: 'getKeys',
    value: function getKeys() {
      return tokenKeys.map(function (i) {
        return i.key;
      });
    }
  }, {
    key: 'getAlternatives',
    value: function getAlternatives() {
      return alternativeTokenKeys;
    }
  }, {
    key: 'getConditions',
    value: function getConditions() {
      return conditions;
    }
  }, {
    key: 'searchByKey',
    value: function searchByKey(key) {
      return tokenKeys.find(function (tokenKey) {
        return tokenKey.key === key;
      }) || null;
    }
  }, {
    key: 'searchBySymbol',
    value: function searchBySymbol(symbol) {
      return tokenKeys.find(function (tokenKey) {
        return tokenKey.symbol === symbol;
      }) || null;
    }
  }, {
    key: 'searchByKeyParam',
    value: function searchByKeyParam(keyParam) {
      return tokenKeysWithAlternative.find(function (tokenKey) {
        var tokenKeyParam = tokenKey.key;

        if (tokenKey.param) {
          tokenKeyParam += '_' + tokenKey.param;
        }

        return keyParam === tokenKeyParam;
      }) || null;
    }
  }, {
    key: 'searchByConditionUrl',
    value: function searchByConditionUrl(url) {
      return conditions.find(function (condition) {
        return condition.url === url;
      }) || null;
    }
  }, {
    key: 'searchByConditionKeyValue',
    value: function searchByConditionKeyValue(key, value) {
      return conditions.find(function (condition) {
        return condition.tokenKey === key && condition.value === value;
      }) || null;
    }
  }]);

  return FilteredSearchTokenKeys;
}();

window.gl = window.gl || {};
gl.FilteredSearchTokenKeys = FilteredSearchTokenKeys;

/***/ }),

/***/ "./filtered_search/filtered_search_tokenizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_token_keys__ = __webpack_require__("./filtered_search/filtered_search_token_keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_token_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__filtered_search_token_keys__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var FilteredSearchTokenizer = function () {
  function FilteredSearchTokenizer() {
    _classCallCheck(this, FilteredSearchTokenizer);
  }

  _createClass(FilteredSearchTokenizer, null, [{
    key: 'processTokens',
    value: function processTokens(input, allowedKeys) {
      // Regex extracts `(token):(symbol)(value)`
      // Values that start with a double quote must end in a double quote (same for single)
      var tokenRegex = new RegExp('(' + allowedKeys.join('|') + '):([~%@]?)(?:(\'[^\']*\'{0,1})|("[^"]*"{0,1})|(\\S+))', 'g');
      var tokens = [];
      var tokenIndexes = []; // stores key+value for simple search
      var lastToken = null;
      var searchToken = input.replace(tokenRegex, function (match, key, symbol, v1, v2, v3) {
        var tokenValue = v1 || v2 || v3;
        var tokenSymbol = symbol;
        var tokenIndex = '';

        if (tokenValue === '~' || tokenValue === '%' || tokenValue === '@') {
          tokenSymbol = tokenValue;
          tokenValue = '';
        }

        tokenIndex = key + ':' + tokenValue;

        // Prevent adding duplicates
        if (tokenIndexes.indexOf(tokenIndex) === -1) {
          tokenIndexes.push(tokenIndex);

          tokens.push({
            key: key,
            value: tokenValue || '',
            symbol: tokenSymbol || ''
          });
        }

        return '';
      }).replace(/\s{2,}/g, ' ').trim() || '';

      if (tokens.length > 0) {
        var last = tokens[tokens.length - 1];
        var lastString = last.key + ':' + last.symbol + last.value;
        lastToken = input.lastIndexOf(lastString) === input.length - lastString.length ? last : searchToken;
      } else {
        lastToken = searchToken;
      }

      return {
        tokens: tokens,
        lastToken: lastToken,
        searchToken: searchToken
      };
    }
  }]);

  return FilteredSearchTokenizer;
}();

window.gl = window.gl || {};
gl.FilteredSearchTokenizer = FilteredSearchTokenizer;

/***/ }),

/***/ "./filtered_search/filtered_search_visual_tokens.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__ = __webpack_require__("./lib/utils/ajax_cache.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container__ = __webpack_require__("./filtered_search/container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_users_cache__ = __webpack_require__("./lib/utils/users_cache.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


 /* global Flash */



var FilteredSearchVisualTokens = function () {
  function FilteredSearchVisualTokens() {
    _classCallCheck(this, FilteredSearchVisualTokens);
  }

  _createClass(FilteredSearchVisualTokens, null, [{
    key: 'getLastVisualTokenBeforeInput',
    value: function getLastVisualTokenBeforeInput() {
      var inputLi = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.input-token');
      var lastVisualToken = inputLi && inputLi.previousElementSibling;

      return {
        lastVisualToken: lastVisualToken,
        isLastVisualTokenValid: lastVisualToken === null || lastVisualToken.className.indexOf('filtered-search-term') !== -1 || lastVisualToken && lastVisualToken.querySelector('.value') !== null
      };
    }
  }, {
    key: 'unselectTokens',
    value: function unselectTokens() {
      var otherTokens = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelectorAll('.js-visual-token .selectable.selected');
      [].forEach.call(otherTokens, function (t) {
        return t.classList.remove('selected');
      });
    }
  }, {
    key: 'selectToken',
    value: function selectToken(tokenButton) {
      var forceSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = tokenButton.classList.contains('selected');
      FilteredSearchVisualTokens.unselectTokens();

      if (!selected || forceSelection) {
        tokenButton.classList.add('selected');
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      var selected = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.js-visual-token .selected');

      if (selected) {
        var li = selected.closest('.js-visual-token');
        li.parentElement.removeChild(li);
      }
    }
  }, {
    key: 'createVisualTokenElementHTML',
    value: function createVisualTokenElementHTML() {
      var canEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var removeTokenMarkup = '';
      if (canEdit) {
        removeTokenMarkup = '\n        <div class="remove-token" role="button">\n          <i class="fa fa-close"></i>\n        </div>\n      ';
      }

      return '\n      <div class="selectable" role="button">\n        <div class="name"></div>\n        <div class="value-container">\n          <div class="value"></div>\n          ' + removeTokenMarkup + '\n        </div>\n      </div>\n    ';
    }
  }, {
    key: 'setTokenStyle',
    value: function setTokenStyle(tokenContainer, backgroundColor, textColor) {
      var token = tokenContainer;

      // Labels with linear gradient should not override default background color
      if (backgroundColor.indexOf('linear-gradient') === -1) {
        token.style.backgroundColor = backgroundColor;
      }

      token.style.color = textColor;

      if (textColor === '#FFFFFF') {
        var removeToken = token.querySelector('.remove-token');
        removeToken.classList.add('inverted');
      }

      return token;
    }
  }, {
    key: 'preprocessLabel',
    value: function preprocessLabel(labelsEndpoint, labels) {
      var processed = labels;

      if (!labels.preprocessed) {
        processed = gl.DropdownUtils.duplicateLabelPreprocessing(labels);
        __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].override(labelsEndpoint, processed);
        processed.preprocessed = true;
      }

      return processed;
    }
  }, {
    key: 'updateLabelTokenColor',
    value: function updateLabelTokenColor(tokenValueContainer, tokenValue) {
      var filteredSearchInput = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.filtered-search');
      var baseEndpoint = filteredSearchInput.dataset.baseEndpoint;
      var labelsEndpoint = baseEndpoint + '/labels.json';

      return __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].retrieve(labelsEndpoint).then(FilteredSearchVisualTokens.preprocessLabel.bind(null, labelsEndpoint)).then(function (labels) {
        var matchingLabel = (labels || []).find(function (label) {
          return '~' + gl.DropdownUtils.getEscapedText(label.title) === tokenValue;
        });

        if (!matchingLabel) {
          return;
        }

        FilteredSearchVisualTokens.setTokenStyle(tokenValueContainer, matchingLabel.color, matchingLabel.text_color);
      }).catch(function () {
        return new Flash('An error occurred while fetching label colors.');
      });
    }
  }, {
    key: 'updateUserTokenAppearance',
    value: function updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue) {
      if (tokenValue === 'none') {
        return Promise.resolve();
      }

      var username = tokenValue.replace(/^@/, '');
      return __WEBPACK_IMPORTED_MODULE_3__lib_utils_users_cache__["a" /* default */].retrieve(username).then(function (user) {
        if (!user) {
          return;
        }

        /* eslint-disable no-param-reassign */
        tokenValueContainer.dataset.originalValue = tokenValue;
        tokenValueElement.innerHTML = '\n          <img class="avatar s20" src="' + user.avatar_url + '" alt="' + user.name + '\'s avatar">\n          ' + user.name + '\n        ';
        /* eslint-enable no-param-reassign */
      })
      // ignore error and leave username in the search bar
      .catch(function () {});
    }
  }, {
    key: 'renderVisualTokenValue',
    value: function renderVisualTokenValue(parentElement, tokenName, tokenValue) {
      var tokenValueContainer = parentElement.querySelector('.value-container');
      var tokenValueElement = tokenValueContainer.querySelector('.value');
      tokenValueElement.innerText = tokenValue;

      var tokenType = tokenName.toLowerCase();
      if (tokenType === 'label') {
        FilteredSearchVisualTokens.updateLabelTokenColor(tokenValueContainer, tokenValue);
      } else if (tokenType === 'author' || tokenType === 'assignee') {
        FilteredSearchVisualTokens.updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue);
      }
    }
  }, {
    key: 'addVisualTokenElement',
    value: function addVisualTokenElement(name, value, isSearchTerm, canEdit) {
      var li = document.createElement('li');
      li.classList.add('js-visual-token');
      li.classList.add(isSearchTerm ? 'filtered-search-term' : 'filtered-search-token');

      if (value) {
        li.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML(canEdit);
        FilteredSearchVisualTokens.renderVisualTokenValue(li, name, value);
      } else {
        li.innerHTML = '<div class="name"></div>';
      }
      li.querySelector('.name').innerText = name;

      var tokensContainer = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.tokens-container');
      var input = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.filtered-search');
      tokensContainer.insertBefore(li, input.parentElement);
    }
  }, {
    key: 'addValueToPreviousVisualTokenElement',
    value: function addValueToPreviousVisualTokenElement(value) {
      var _FilteredSearchVisual = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual.isLastVisualTokenValid;

      if (!isLastVisualTokenValid && lastVisualToken.classList.contains('filtered-search-token')) {
        var name = FilteredSearchVisualTokens.getLastTokenPartial();
        lastVisualToken.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML();
        lastVisualToken.querySelector('.name').innerText = name;
        FilteredSearchVisualTokens.renderVisualTokenValue(lastVisualToken, name, value);
      }
    }
  }, {
    key: 'addFilterVisualToken',
    value: function addFilterVisualToken(tokenName, tokenValue, canEdit) {
      var _FilteredSearchVisual2 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual2.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      var addVisualTokenElement = FilteredSearchVisualTokens.addVisualTokenElement;

      if (isLastVisualTokenValid) {
        addVisualTokenElement(tokenName, tokenValue, false, canEdit);
      } else {
        var previousTokenName = lastVisualToken.querySelector('.name').innerText;
        var tokensContainer = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.tokens-container');
        tokensContainer.removeChild(lastVisualToken);

        var value = tokenValue || tokenName;
        addVisualTokenElement(previousTokenName, value, false, canEdit);
      }
    }
  }, {
    key: 'addSearchVisualToken',
    value: function addSearchVisualToken(searchTerm) {
      var _FilteredSearchVisual3 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual3.lastVisualToken;

      if (lastVisualToken && lastVisualToken.classList.contains('filtered-search-term')) {
        lastVisualToken.querySelector('.name').innerText += ' ' + searchTerm;
      } else {
        FilteredSearchVisualTokens.addVisualTokenElement(searchTerm, null, true);
      }
    }
  }, {
    key: 'getLastTokenPartial',
    value: function getLastTokenPartial() {
      var _FilteredSearchVisual4 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual4.lastVisualToken;

      if (!lastVisualToken) return '';

      var valueContainer = lastVisualToken.querySelector('.value-container');
      var originalValue = valueContainer && valueContainer.dataset.originalValue;
      if (originalValue) {
        return originalValue;
      }

      var value = lastVisualToken.querySelector('.value');
      var name = lastVisualToken.querySelector('.name');

      var valueText = value ? value.innerText : '';
      var nameText = name ? name.innerText : '';

      return valueText || nameText;
    }
  }, {
    key: 'removeLastTokenPartial',
    value: function removeLastTokenPartial() {
      var _FilteredSearchVisual5 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual5.lastVisualToken;

      if (lastVisualToken) {
        var value = lastVisualToken.querySelector('.value');

        if (value) {
          var button = lastVisualToken.querySelector('.selectable');
          var valueContainer = lastVisualToken.querySelector('.value-container');
          button.removeChild(valueContainer);
          lastVisualToken.innerHTML = button.innerHTML;
        } else {
          lastVisualToken.closest('.tokens-container').removeChild(lastVisualToken);
        }
      }
    }
  }, {
    key: 'tokenizeInput',
    value: function tokenizeInput() {
      var input = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.filtered-search');

      var _gl$FilteredSearchVis = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _gl$FilteredSearchVis.isLastVisualTokenValid;

      if (input.value) {
        if (isLastVisualTokenValid) {
          gl.FilteredSearchVisualTokens.addSearchVisualToken(input.value);
        } else {
          FilteredSearchVisualTokens.addValueToPreviousVisualTokenElement(input.value);
        }

        input.value = '';
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(token) {
      var input = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.filtered-search');

      FilteredSearchVisualTokens.tokenizeInput();

      // Replace token with input field
      var tokenContainer = token.parentElement;
      var inputLi = input.parentElement;
      tokenContainer.replaceChild(inputLi, token);

      var nameElement = token.querySelector('.name');
      var value = void 0;

      if (token.classList.contains('filtered-search-token')) {
        FilteredSearchVisualTokens.addFilterVisualToken(nameElement.innerText);

        var valueContainerElement = token.querySelector('.value-container');
        value = valueContainerElement.dataset.originalValue;

        if (!value) {
          var valueElement = valueContainerElement.querySelector('.value');
          value = valueElement.innerText;
        }
      }

      // token is a search term
      if (!value) {
        value = nameElement.innerText;
      }

      input.value = value;

      // Opens dropdown
      var inputEvent = new Event('input');
      input.dispatchEvent(inputEvent);

      // Adds cursor to input
      input.focus();
    }
  }, {
    key: 'moveInputToTheRight',
    value: function moveInputToTheRight() {
      var input = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.filtered-search');

      if (!input) return;

      var inputLi = input.parentElement;
      var tokenContainer = __WEBPACK_IMPORTED_MODULE_2__container__["a" /* default */].container.querySelector('.tokens-container');

      FilteredSearchVisualTokens.tokenizeInput();

      if (!tokenContainer.lastElementChild.isEqualNode(inputLi)) {
        var _gl$FilteredSearchVis2 = gl.FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
            isLastVisualTokenValid = _gl$FilteredSearchVis2.isLastVisualTokenValid;

        if (!isLastVisualTokenValid) {
          var lastPartial = gl.FilteredSearchVisualTokens.getLastTokenPartial();
          gl.FilteredSearchVisualTokens.removeLastTokenPartial();
          gl.FilteredSearchVisualTokens.addSearchVisualToken(lastPartial);
        }

        tokenContainer.removeChild(inputLi);
        tokenContainer.appendChild(inputLi);
      }
    }
  }]);

  return FilteredSearchVisualTokens;
}();

window.gl = window.gl || {};
gl.FilteredSearchVisualTokens = FilteredSearchVisualTokens;

/***/ }),

/***/ "./filtered_search/recent_searches_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_recent_searches_dropdown_content__ = __webpack_require__("./filtered_search/components/recent_searches_dropdown_content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__("./filtered_search/event_hub.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var RecentSearchesRoot = function () {
  function RecentSearchesRoot(recentSearchesStore, recentSearchesService, wrapperElement) {
    _classCallCheck(this, RecentSearchesRoot);

    this.store = recentSearchesStore;
    this.service = recentSearchesService;
    this.wrapperElement = wrapperElement;
  }

  _createClass(RecentSearchesRoot, [{
    key: 'init',
    value: function init() {
      this.bindEvents();
      this.render();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onRequestClearRecentSearchesWrapper = this.onRequestClearRecentSearches.bind(this);

      __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$on('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$off('requestClearRecentSearches', this.onRequestClearRecentSearchesWrapper);
    }
  }, {
    key: 'render',
    value: function render() {
      var state = this.store.state;
      this.vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: this.wrapperElement,
        data: function data() {
          return state;
        },

        template: '\n        <recent-searches-dropdown-content\n          :items="recentSearches"\n          :is-local-storage-available="isLocalStorageAvailable"\n          :allowed-keys="allowedKeys"\n          />\n      ',
        components: {
          'recent-searches-dropdown-content': __WEBPACK_IMPORTED_MODULE_1__components_recent_searches_dropdown_content__["a" /* default */]
        }
      });
    }
  }, {
    key: 'onRequestClearRecentSearches',
    value: function onRequestClearRecentSearches() {
      var resultantSearches = this.store.setRecentSearches([]);
      this.service.save(resultantSearches);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.unbindEvents();
      if (this.vm) {
        this.vm.$destroy();
      }
    }
  }]);

  return RecentSearchesRoot;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecentSearchesRoot);

/***/ }),

/***/ "./filtered_search/services/recent_searches_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recent_searches_service_error__ = __webpack_require__("./filtered_search/services/recent_searches_service_error.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var RecentSearchesService = function () {
  function RecentSearchesService() {
    var localStorageKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'issuable-recent-searches';

    _classCallCheck(this, RecentSearchesService);

    this.localStorageKey = localStorageKey;
  }

  _createClass(RecentSearchesService, [{
    key: 'fetch',
    value: function fetch() {
      if (!RecentSearchesService.isAvailable()) {
        var error = new __WEBPACK_IMPORTED_MODULE_0__recent_searches_service_error__["a" /* default */]();
        return Promise.reject(error);
      }

      var input = window.localStorage.getItem(this.localStorageKey);

      var searches = [];
      if (input && input.length > 0) {
        try {
          searches = JSON.parse(input);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      return Promise.resolve(searches);
    }
  }, {
    key: 'save',
    value: function save() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!RecentSearchesService.isAvailable()) return;

      window.localStorage.setItem(this.localStorageKey, JSON.stringify(searches));
    }
  }], [{
    key: 'isAvailable',
    value: function isAvailable() {
      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    }
  }]);

  return RecentSearchesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecentSearchesService);

/***/ }),

/***/ "./filtered_search/services/recent_searches_service_error.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentSearchesServiceError = function RecentSearchesServiceError(message) {
  _classCallCheck(this, RecentSearchesServiceError);

  this.name = 'RecentSearchesServiceError';
  this.message = message || 'Recent Searches Service is unavailable';
};

// Can't use `extends` for builtin prototypes and get true inheritance yet


RecentSearchesServiceError.prototype = Error.prototype;

/* harmony default export */ __webpack_exports__["a"] = (RecentSearchesServiceError);

/***/ }),

/***/ "./filtered_search/stores/recent_searches_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RecentSearchesStore = function () {
  function RecentSearchesStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allowedKeys = arguments[1];

    _classCallCheck(this, RecentSearchesStore);

    this.state = Object.assign({
      isLocalStorageAvailable: true,
      recentSearches: [],
      allowedKeys: allowedKeys
    }, initialState);
  }

  _createClass(RecentSearchesStore, [{
    key: 'addRecentSearch',
    value: function addRecentSearch(newSearch) {
      this.setRecentSearches([newSearch].concat(this.state.recentSearches));

      return this.state.recentSearches;
    }
  }, {
    key: 'setRecentSearches',
    value: function setRecentSearches() {
      var searches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var trimmedSearches = searches.map(function (search) {
        return search.trim();
      });
      this.state.recentSearches = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(trimmedSearches).slice(0, 5);
      return this.state.recentSearches;
    }
  }]);

  return RecentSearchesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (RecentSearchesStore);

/***/ }),

/***/ "./lib/utils/dom_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClassIfElementExists; });
/* eslint-disable import/prefer-default-export */

var addClassIfElementExists = function addClassIfElementExists(element, className) {
  if (element) {
    element.classList.add(className);
  }
};

/***/ }),

/***/ "./lib/utils/users_cache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cache__ = __webpack_require__("./lib/utils/cache.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var UsersCache = function (_Cache) {
  _inherits(UsersCache, _Cache);

  function UsersCache() {
    _classCallCheck(this, UsersCache);

    return _possibleConstructorReturn(this, (UsersCache.__proto__ || Object.getPrototypeOf(UsersCache)).apply(this, arguments));
  }

  _createClass(UsersCache, [{
    key: 'retrieve',
    value: function retrieve(username) {
      var _this2 = this;

      if (this.hasData(username)) {
        return Promise.resolve(this.get(username));
      }

      return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].users('', { username: username }).then(function (users) {
        if (!users.length) {
          throw new Error('User "' + username + '" could not be found!');
        }

        if (users.length > 1) {
          throw new Error('Expected username "' + username + '" to be unique!');
        }

        var user = users[0];
        _this2.internalStorage[username] = user;
        return user;
      });
      // missing catch is intentional, error handling depends on use case
    }
  }]);

  return UsersCache;
}(__WEBPACK_IMPORTED_MODULE_1__cache__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new UsersCache());

/***/ })

},["./filtered_search/filtered_search_bundle.js"]);


// WEBPACK FOOTER //
// filtered_search.9902dab83525a03a81c6.bundle.js